import { render } from "./UserSidebar.vue?vue&type=template&id=59a9eb31&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"

import "./UserSidebar.vue?vue&type=style&index=0&id=59a9eb31&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a9eb31"]])

export default __exports__